/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { VerifyUserOptions, VerifyUserResponses } from '../types/VerifyUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Verify a user by ID
 * {@link /v1/user/:user_id/verify}
 */
export function verifyUser<ThrowOnError extends boolean = true>(
  options: Options<VerifyUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<VerifyUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/user/{user_id}/verify',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<VerifyUserResponses, ThrowOnError>>,
  )
}
